import { Box, Typography } from '@mui/material'
import { useTokens } from '../theme'

/** "Orbimail" with a small gold planet: the brand's one signature detail (orbit motif from the name). */
export function Wordmark({ size = 22, color = 'text.primary' }: { size?: number; color?: string }) {
  const t = useTokens()
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'flex-start', gap: `${Math.round(size * 0.12)}px` }}>
      <Typography component="span" sx={{ fontSize: size, fontWeight: 700, letterSpacing: '-0.035em', color, lineHeight: 1 }}>Orbimail</Typography>
      <Box component="span" aria-hidden sx={{ width: size * 0.26, height: size * 0.26, borderRadius: '50%', bgcolor: t.gold, mt: `${Math.round(size * 0.08)}px` }} />
    </Box>
  )
}
